import { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import _, { create } from 'lodash';
import dayjs from 'dayjs';
import Yup from '../../../utils/yup';
import utc from 'dayjs/plugin/utc';
import { add, bignumber, divide, multiply } from 'mathjs';
import { v4 as uuidv4 } from 'uuid';

import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import productionService from '../../../service/production.service';
import { DeleteDialogUI, FormButtonPanelUI, FormHeaderUI, ConfirmDialogUI, ButtonUI } from '../../Interface';
import ProductionFields from './ProductionFields';
import ProductionTabs from './ProductionTabs';
import sourcelistService from '../../../service/sourcelist.service';
import { useParams } from 'react-router-dom';
import HistoryDialog from '../../History/HistoryDialog';
import History from '../../History/History';
import { JokerFieldTypes } from '../../../config/joker';
import { cleanValues, generateAutocompleteItems, getJokerFieldType } from '../../../utils/helper';
import { IssueMethod } from '../../../config/production';
import { useLoader } from '../../../provider/LoaderProvider';
import masterDataService from '../../../service/masterData.service';

export const ProductionPage = ({ productionState, dialog, items }) => {
  const {
    selectedValues,
    setSelectedValues,
    viewField,
    setViewField,
    operatorsDisabled,
    setOperatorsDisabled,
    autocompleteOptions,
    setRefetchTable,
    setRowSelectionModel,
    user,
    canEdit,
    submenu,
    autocompleteData,
    config,
    params,
    setAutoCompleteOptions,
    setAutocompleteData,
    setLoading,
    canCopy,
    canDelete,
    jokerFields,
    jokerLineFields,
    isLoading,
    getJokerFields,
  } = productionState;
  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showConfirmDialogForStatus, setShowConfirmDialogForStatus] = useState(false);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);

  const [defaultValues, setDefaultValues] = useState({});
  const [initValues, setInitValues] = useState({});

  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});

  const [sourceData, setSourceData] = useState({});

  const formikRef = useRef(null);

  const defaultOperation = {
    id: null,
    isNew: true,
    operationId: null,
    resourceOneId: null,
    startDate: dayjs(new Date()),
    dependence: config?.defaultDependence,
    description: '',
    createdBy: user.userId,
    label: '',
    baseRate: 1,
    plannedQty: 1,
    fixedLeadTime: 0,
    baseQty: 1,
    quantityUnitId: config?.defOperationQtyUnit,
    productionReport: [],
    productionStatusId:
      autocompleteData?.prodStatus?.find((defStatus) => defStatus.defaultValue === true)?.code ?? null,
  };

  const defaultItem = {
    id: null,
    isNew: true,
    itemCode: null,
    quantity: 1,
    createdBy: user.userId,
    baseRate: 1,
    description: '',
    secondaryProduct: false,
    whsCode: null,
    issueMethod: IssueMethod.MANUAL,
    isseudQuantity: null,
    joker_char1: '',
    joker_char2: '',
    joker_num1: null,
    joker_num2: null,
  };

  const def = {
    workingNumber: '',
    baseDocNum: '',
    projectId: null,
    articleNumber: '',
    articleName: '',
    productionQuantity: 1,
    me: null,
    startDate: dayjs(new Date()),
    endDate: dayjs(new Date()).add(1, 'hour'),
    productionStatusId: null,
    priorityId: null,
    companyId: null,
    description: '',
    productionOperation: [],
    productionItem: [],
    userId: null,
    baseId: '',
    baseLine: '',
    level: '',
    baseDocType: null,
    finishedItemCode: null,
    reference: '',
    joker_int1: '',
    joker_int2: '',
    joker_int3: '',
    joker_int4: '',
    joker_int5: '',
    joker_int6: '',
    joker_int7: '',
    joker_int8: '',
    joker_char1: '',
    joker_char2: '',
    joker_char3: '',
    joker_char4: '',
    joker_char5: '',
    joker_char6: '',
    joker_char7: '',
    joker_char8: '',
    joker_char9: '',
    joker_char10: '',
    joker_char11: '',
    joker_char12: '',
    joker_char13: '',
    joker_char14: '',
    joker_char15: '',
    joker_char16: '',
    joker_char17: '',
    joker_char18: '',
    joker_char19: '',
    joker_char20: '',
    joker_char21: '',
    joker_char22: '',
    joker_char23: '',
    joker_char24: '',
    joker_char25: '',
    joker_char26: '',
    joker_char27: '',
    joker_char28: '',
    joker_num1: '',
    joker_num2: '',
    joker_num3: '',
    joker_num4: '',
    joker_num5: '',
    completedQuantity: 0,
    secondayProductQuantity: 0,
    whsCode: null,
    weight: '',
    weightPerItem: '',
    productionConfirmation: [],
  };

  useEffect(() => {
    if (submenu) {
      initDefaultValues();
    }
  }, [submenu]);

  useEffect(() => {
    setDefaultValues(def);
    getJokerFields();
  }, []);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          productionStatusId:
            autocompleteData?.prodStatus?.find((defStatus) => defStatus.defaultValue === true)?.code ?? null,
          priorityId: autocompleteData?.priority?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          priority: autocompleteData?.priority?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    if (Object.keys(user).length > 0) {
      setDefaultValues((prev) => {
        return { ...prev, userId: user?.userId };
      });
    }
  }, [user]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!_.isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  useEffect(() => {
    if (id) {
      productionService.getProductionById(id).then((data) => {
        setSelectedValues(data);
      });
    } else {
      setSelectedValues(defaultSelectedValues);
    }
  }, [defaultSelectedValues, id]);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .priorityToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .usersToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceOneToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .operationToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .quantityUnitToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .productionStatusToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .warehouseToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    if (!items) {
      promiseArray.push(
        new Promise((resolve, reject) => {
          masterDataService
            .itemsFromTableToForm()
            .then((data) => {
              resolve(data);
            })
            .catch((e) => {
              reject(e);
            });
        })
      );
    }

    showLoader();

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          priority: resp[0],
          company: resp[1],
          user: resp[2],
          project: resp[3],
          resourceOne: resp[4],
          operation: resp[5],
          quantityUnit: resp[6],
          prodStatus: resp[7],
          warehouse: resp[8],
          items: items ? items : resp[9],
        };
        setAutocompleteData(aData);
        const filteredCompany = aData.company?.filter((company) => company.customer);

        const acOptions = {
          priority: generateAutocompleteItems(aData.priority.priorityListItems, 'itemName', 'itemId'),
          company: generateAutocompleteItems(filteredCompany, 'name', 'id'),
          user: generateAutocompleteItems(aData.user, 'userName', 'userId'),
          project: generateAutocompleteItems(aData.project, 'projectName', 'projectId'),
          resourceOne: generateAutocompleteItems(aData.resourceOne, 'name', 'id'),
          operation: generateAutocompleteItems(aData.operation, ['code', 'operationName'], 'operationId'),
          quantityUnit: generateAutocompleteItems(aData.quantityUnit, 'name', 'id'),
          items: generateAutocompleteItems(aData.items, ['itemCode', 'itemName'], 'itemCode'),
          prodStatus: generateAutocompleteItems(aData.prodStatus, 'name', 'code'),
          warehouse: generateAutocompleteItems(aData.warehouse, 'name', 'code'),
        };
        setAutoCompleteOptions(acOptions);
      })
      .finally(() => {
        hideLoader();
        setLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    workingNumber: Yup.string().nullable(),
    baseDocNum: Yup.string().nullable(),
    projectId: Yup.string().nullable(),
    articleNumber: Yup.string().required(),
    articleName: Yup.string().required(),
    productionQuantity: Yup.number().nullable().positive(),
    me: Yup.string().nullable().required(),
    startDate: Yup.string(),
    endDate: Yup.string(),
    productionStatusId: Yup.string().nullable(),
    priorityId: Yup.string().nullable(),
    companyId: Yup.string().nullable(),
    description: Yup.string().nullable(),
    baseId: Yup.string().nullable(),
    baseLine: Yup.string().nullable(),
    finishedItemCode: Yup.string().nullable(),
    reference: Yup.string().nullable(),
    completedQuantity: Yup.number().nullable().default(0),
    secondayProductQuantity: Yup.number().nullable().default(0),
    whsCode: Yup.string().nullable(),
    weight: Yup.number().nullable(),
    weightPerItem: Yup.number().nullable(),
    variantItemCode: Yup.string().nullable(),
    variantFinishedItemCode: Yup.string().nullable(),
    variantNote: Yup.string().nullable(),
    productionOperation: Yup.array().of(
      Yup.object().shape({
        operationId: Yup.string().required(),
        resourceOneId: Yup.string().required(),
        productionStatusId: Yup.string().required(),
        startDate: Yup.string().required(),
        dependence: Yup.string().nullable(),
        description: Yup.string().nullable(),
        quantityUnitId: Yup.string().required(),
        plannedQty: Yup.number().required().positive(),
        baseRate: Yup.number().required().positive(),
        fixedLeadTime: Yup.number().required().min(0),
        baseQty: Yup.number().required().positive(),
      })
    ),
    productionItem: Yup.array().of(
      Yup.object().shape({
        itemCode: Yup.string().required(),
        quantity: Yup.number().required(),
        description: Yup.string().nullable(),
        secondaryProduct: Yup.boolean(),
        whsCode: Yup.string().nullable(),
        issueMethod: Yup.string().nullable(),
        isseudQuantity: Yup.number().nullable(),
        ...(jokerLineFields.length > 0
          ? Object.fromEntries(
              jokerLineFields.map((field) => {
                const fieldType = getJokerFieldType(field);
                return [
                  field.field,
                  fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
                ];
              })
            )
          : {}),
      })
    ),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
  });

  const valuesToForm = () => {
    const {
      workingNumber,
      baseDocNum,
      projectId,
      articleNumber,
      articleName,
      productionQuantity,
      me,
      startDate,
      endDate,
      productionStatusId,
      priorityId,
      userId,
      companyId,
      description,
      productionOperation,
      productionItem,
      baseId,
      baseLine,
      level,
      baseDocType,
      finishedItemCode,
      reference,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
      joker_int6,
      joker_int7,
      joker_int8,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_char6,
      joker_char7,
      joker_char8,
      joker_char9,
      joker_char10,
      joker_char11,
      joker_char12,
      joker_char13,
      joker_char14,
      joker_char15,
      joker_char16,
      joker_char17,
      joker_char18,
      joker_char19,
      joker_char20,
      joker_char21,
      joker_char22,
      joker_char23,
      joker_char24,
      joker_char25,
      joker_char26,
      joker_char27,
      joker_char28,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      completedQuantity,
      secondayProductQuantity,
      whsCode,
      weight,
      weightPerItem,
      variantItemCode,
      variantFinishedItemCode,
      variantNote,
      productionConfirmation,
    } = selectedValues;

    setInitValues({
      workingNumber,
      baseDocNum,
      projectId,
      articleNumber,
      articleName,
      productionQuantity,
      me,
      startDate: dayjs(startDate),
      endDate: dayjs(endDate),
      productionStatusId,
      priorityId,
      userId,
      companyId,
      description,
      baseId: baseId || '',
      baseLine: baseLine || '',
      level,
      baseDocType,
      finishedItemCode,
      reference,
      joker_int1: joker_int1 || '',
      joker_int2: joker_int2 || '',
      joker_int3: joker_int3 || '',
      joker_int4: joker_int4 || '',
      joker_int5: joker_int5 || '',
      joker_int6: joker_int6 || '',
      joker_int7: joker_int7 || '',
      joker_int8: joker_int8 || '',
      joker_char1: joker_char1 || '',
      joker_char2: joker_char2 || '',
      joker_char3: joker_char3 || '',
      joker_char4: joker_char4 || '',
      joker_char5: joker_char5 || '',
      joker_char6: joker_char6 || '',
      joker_char7: joker_char7 || '',
      joker_char8: joker_char8 || '',
      joker_char9: joker_char9 || '',
      joker_char10: joker_char10 || '',
      joker_char11: joker_char11 || '',
      joker_char12: joker_char12 || '',
      joker_char13: joker_char13 || '',
      joker_char14: joker_char14 || '',
      joker_char15: joker_char15 || '',
      joker_char16: joker_char16 || '',
      joker_char17: joker_char17 || '',
      joker_char18: joker_char18 || '',
      joker_char19: joker_char19 || '',
      joker_char20: joker_char20 || '',
      joker_char21: joker_char21 || '',
      joker_char22: joker_char22 || '',
      joker_char23: joker_char23 || '',
      joker_char24: joker_char24 || '',
      joker_char25: joker_char25 || '',
      joker_char26: joker_char26 || '',
      joker_char27: joker_char27 || '',
      joker_char28: joker_char28 || '',
      joker_num1: joker_num1 || '',
      joker_num2: joker_num2 || '',
      joker_num3: joker_num3 || '',
      joker_num4: joker_num4 || '',
      joker_num5: joker_num5 || '',
      completedQuantity,
      secondayProductQuantity,
      whsCode,
      weight: weight || '',
      weightPerItem: weightPerItem || '',
      variantItemCode: variantItemCode || '',
      variantFinishedItemCode: variantFinishedItemCode || '',
      variantNote: variantNote || '',
      productionOperation:
        productionOperation &&
        productionOperation.map((po) => ({
          id: po.id,
          operationId: po.operationId,
          resourceOneId: po.resourceOneId,
          startDate: po.startDate,
          dependence: po.dependence,
          visOrder: po.visOrder,
          description: po.description,
          createdBy: po.user?.userId,
          label: po.label,
          baseRate: po.baseRate,
          productionReport: po.productionReport,
          productionStatusId: po.productionStatusId,
          plannedQty: po.plannedQty,
          quantityUnitId: po.quantityUnitId,
          fixedLeadTime: po.fixedLeadTime,
          baseQty: po.baseQty,
        })),
      productionItem:
        productionItem &&
        productionItem.map((po) => ({
          id: po.id,
          itemCode: po.itemCode,
          quantity: po.quantity,
          baseRate: po.baseRate,
          description: po.description,
          quantityUnitId: po.item?.quantityUnitId,
          secondaryProduct: po.secondaryProduct,
          whsCode: po.whsCode,
          issueMethod: po.issueMethod,
          isseudQuantity: po.isseudQuantity,
          joker_char1: po.joker_char1,
          joker_char2: po.joker_char2,
          joker_num1: po.joker_num1,
          joker_num2: po.joker_num2,
        })),
      productionConfirmation,
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField || !dialog.isUpdate) {
      handleInsertObject(values, resetForm);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
      baseId: parseInt(values.baseId),
      baseLine: parseInt(values.baseLine),
      updatedBy: user.userId,
    };

    productionService.updateProduction(updData, selectedValues.id).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });
      if (dialog) {
        dialog.setProductionChanged(true);
        dialog.handleClose();
      }
      setSelectedValues(data);
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
    });
  };

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...cleanValues(values),
      baseId: parseInt(values.baseId),
      baseLine: parseInt(values.baseLine),
      createdBy: user.userId,
    };

    productionService
      .createProduction(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        setRowSelectionModel(data.id);
        setSelectedValues(data);
        setRefetchTable(true);
        setAddField(true);
        setViewField(true);

        if (dialog) {
          dialog.setProductionChanged(true);
          dialog.handleClose();
          setSelectedValues(defaultSelectedValues);
        }
      })
      .finally(() => {
        //@TODO loader
      });
  };

  dayjs.extend(utc);

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    productionService.deleteProduction(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      if (dialog) {
        dialog.setProductionChanged(true);
        dialog.handleClose();
      }
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultSelectedValues);
    });
  };

  const getSourceData = async (itemCode, fromLoadButton = false) => {
    if (!itemCode) {
      setSourceData({});
      return;
    }

    const sd = await sourcelistService.getSourcelistByItemCode(itemCode);
    setSourceData(sd);
    if (
      !fromLoadButton &&
      ((Object.keys(sd).length > 0 && !viewField) ||
        (Object.keys(sd).length > 0 && dialog && dialog?.isUpdate && !viewField) ||
        (Object.keys(sd).length > 0 && dialog && !dialog?.isUpdate && !dialog.isView))
    ) {
      setShowConfirmDialog(true);
    } else if (fromLoadButton) {
      if (formikRef.current) {
        addSourceLine(formikRef.current.setFieldValue, formikRef.current.values, sd);
      }
    }
  };

  const addSourceLine = (setFieldValue, values, sourceList = null) => {
    const sd = sourceList || { ...sourceData };

    if (!Object.keys(sd).length)
      return addNotification({
        content: 'Nincs forrásjegyzék!',
        type: NotificationType.ERROR,
      });

    for (const op of sd.sourceListOperation) {
      if (op.sourceListOperationMachine.length === 0) {
        const findOperation = autocompleteOptions.operation.find((f) => f.value === op.operationId);
        addNotification({
          content: `Nincs megadva a művelethez tartozó erőforrás! (${findOperation.label})`,
          type: NotificationType.ERROR,
        });
        return;
      }
    }

    for (const key in sd) {
      if (key.startsWith('joker_') || key === 'whsCode' || key === 'weight' || key === 'weightPerItem') {
        setFieldValue(key, sd[key]);
      }
    }

    const newOperationLines = sd.sourceListOperation.map((mp) => {
      const calculatedRate = divide(mp.sourceListOperationMachine[0].neededQuantity, sd.baseQuantity);
      const baseQty = multiply(calculatedRate, values.productionQuantity ?? 1);
      return {
        id: uuidv4(),
        isNew: true,
        operationId: mp.operationId,
        visOrder: mp.visOrder,
        dependence: mp.dependence,
        resourceOneId: mp.sourceListOperationMachine[0].resourceId,
        startDate: dayjs(new Date()),
        quantityUnitId: mp.sourceListOperationMachine[0].quantityUnitId,
        description: mp.description,
        createdBy: user.userId,
        label: '',
        baseRate: calculatedRate,
        productionStatusId:
          autocompleteData?.prodStatus?.find((defStatus) => defStatus.defaultValue === true)?.code ?? null,
        fixedLeadTime: mp.fixedLeadTime ?? 0,
        plannedQty: add(baseQty, mp.fixedLeadTime ?? 0),
        baseQty: baseQty,
      };
    });

    setFieldValue('productionOperation', newOperationLines);

    const newItemLines = sd.sourceListItem.map((mp) => {
      const calculatedRate = divide(mp.neededQuantity, sd.baseQuantity);
      return {
        id: uuidv4(),
        isNew: true,
        itemCode: mp.itemCode,
        quantity: multiply(calculatedRate, values.productionQuantity ?? 1),
        baseRate: calculatedRate,
        joker_char1: mp.joker_char1,
        joker_num1: mp.joker_num1,
        joker_num2: mp.joker_num2,
        description: mp.description,
        whsCode: mp.whsCode,
        secondaryProduct: mp.secondaryProduct,
        issueMethod: mp.issueMethod,
      };
    });

    setFieldValue('productionItem', newItemLines);

    setShowConfirmDialog(false);
  };

  const onAddClick = () => {
    setSelectedValues(defaultSelectedValues);
    setInitValues(defaultValues);
    setViewField(false);
    setAddField(false);
  };

  const onModifyClick = () => {
    setViewField(false);
    setEditButtonvisible(false);
  };

  const onDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  const onCopyClick = () => {
    setViewField(false);
    setAddField(false);
  };

  const printClick = () => {
    addNotification({
      content: 'Nyomtatás elindult!',
      type: NotificationType.INFO,
    });

    productionService.printDocument({
      docId: selectedValues.id,
    });
  };

  const onProductionStatusChange = (setFieldValue, values) => {
    const prodOperation = values.productionOperation.map((prodOp) => {
      return {
        ...prodOp,
        productionStatusId: values.productionStatusId,
      };
    });
    setFieldValue('productionOperation', prodOperation);
    setShowConfirmDialogForStatus(false);
  };

  const handleSourceListTransfer = () => {
    const values = formikRef.current?.values;

    let ic = values?.articleNumber;

    if (values.variantItemCode && values.variantItemCode !== values.articleNumber) ic = values.variantItemCode;

    const hasAccounting = selectedValues?.issues?.length > 0 || selectedValues?.receipts?.length > 0;

    if (hasAccounting) {
      return addNotification({
        content: 'A forrásjegyzék átvétele nem engedélyezett, mert már könyvelés tartozik a gyártási utasításhoz',
        type: NotificationType.ERROR,
      });
    }

    const checkStatus = values.productionStatusId === 'PLANNED' || values.productionStatusId === 'APPROVED';

    if (!checkStatus)
      return addNotification({
        content: 'A forrásjegyzék átvétele csak tervezett vagy jóváhagyott státuszban engedélyezett',
        type: NotificationType.ERROR,
      });

    getSourceData(ic, true);
  };

  return (
    <>
      <>
        <div className="h-full overflow-auto custom-scrollbar">
          <div className="flex items-center flex-wrap justify-between">
            <div className="flex items-center flex-wrap">
              <FormHeaderUI
                addClick={!dialog ? onAddClick : null}
                addDisabled={!viewField || !canEdit}
                modClick={dialog?.isView || dialog?.isUpdate || !dialog ? onModifyClick : null}
                modDisabled={!viewField || operatorsDisabled || !canEdit}
                deleteClick={!dialog || dialog.isUpdate ? onDeleteClick : null}
                deleteDisabled={!viewField || operatorsDisabled || !canEdit || !canDelete}
                copyClick={!dialog || dialog.isUpdate ? onCopyClick : null}
                copyDisabled={!viewField || operatorsDisabled || !canEdit || !canCopy}
              />
              <ButtonUI
                text="Nyomtatás"
                size="sm"
                className="bg-labelColor py-3"
                onClick={() => printClick()}
                disabled={!viewField || operatorsDisabled}
              />

              <ButtonUI
                text="Forrásjegyzék átvétele"
                size="sm"
                className="bg-labelColor py-3 ml-2"
                onClick={() => handleSourceListTransfer()}
                disabled={viewField}
              />
            </div>

            <div>
              <History disabled={operatorsDisabled} onClick={() => setHistoryDialogOpen(!historyDialogOpen)} />
            </div>
          </div>

          <Formik
            initialValues={initValues}
            validationSchema={validationSchema}
            validateOnChange={false}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ values, setFieldValue, errors, validateField, resetForm }) => {
              formikRef.current = { values, setFieldValue };

              const calcOperationQty = async (index) => {
                const op = values.productionOperation?.[index];
                const result = add(
                  multiply(bignumber(op.baseRate ?? 1), bignumber(values.productionQuantity ?? 1)),
                  op.fixedLeadTime
                ).toNumber();

                await setFieldValue(`productionOperation.${index}.plannedQty`, result);
              };

              const calcItemQty = async (index) => {
                const item = values.productionItem?.[index];
                const result = multiply(
                  bignumber(item.baseRate ?? 1),
                  bignumber(values.productionQuantity ?? 1)
                ).toNumber();

                await setFieldValue(`productionItem.${index}.quantity`, result);
              };

              const calculateLineQty = async () => {
                if (values.productionOperation && values.productionOperation.length > 0) {
                  for (const [i] of values.productionOperation.entries()) {
                    await calcOperationQty(i);
                  }
                }

                if (values.productionItem && values.productionItem.length > 0) {
                  for (const [i] of values.productionItem.entries()) {
                    await calcItemQty(i);
                  }
                }
              };

              const calcOperationBaseRate = (index) => {
                const opLine = values.productionOperation[index];
                const newBaseRate = divide(opLine?.baseQty ?? 1, values.productionQuantity ?? 1);
                setFieldValue(`productionOperation.${index}.baseRate`, newBaseRate);

                const plannedQty = add(opLine?.baseQty ?? 0, opLine?.fixedLeadTime ?? 0);

                setFieldValue(`productionOperation.${index}.plannedQty`, plannedQty);
              };

              const calcItemBaseRate = (index) => {
                const itemLine = values.productionItem[index];
                const newBaseRate = divide(itemLine?.quantity ?? 1, values.productionQuantity ?? 1);
                setFieldValue(`productionItem.${index}.baseRate`, newBaseRate);
              };

              return (
                <Form>
                  <ProductionFields
                    viewField={(!dialog || dialog?.isUpdate || dialog.isView) && viewField}
                    submenuId={submenu}
                    selectedValues={selectedValues}
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    validateField={validateField}
                    autocompleteOptions={autocompleteOptions}
                    autocompleteData={autocompleteData}
                    getSourceData={getSourceData}
                    calculateLineQty={calculateLineQty}
                    setShowConfirmDialogForStatus={setShowConfirmDialogForStatus}
                  />

                  {!isLoading && Object.keys(autocompleteData).length > 0 && (
                    <ProductionTabs
                      disabled={(!dialog || dialog?.isUpdate || dialog.isView) && viewField}
                      submenuId={submenu}
                      setFieldValue={setFieldValue}
                      selectedValues={selectedValues}
                      setSelectedValues={setSelectedValues}
                      setDefaultValues={setDefaultValues}
                      user={user}
                      setRefetchTable={setRefetchTable}
                      defaultField={defaultOperation}
                      defaultItem={defaultItem}
                      values={values}
                      errors={errors}
                      autocompleteOptions={autocompleteOptions}
                      autocompleteData={autocompleteData}
                      sourceData={sourceData}
                      calcOperationBaseRate={calcOperationBaseRate}
                      calcItemBaseRate={calcItemBaseRate}
                      params={params}
                      jokerFields={jokerFields}
                      jokerLineFields={jokerLineFields}
                    />
                  )}
                  <FormButtonPanelUI
                    onCancelClick={() => {
                      setViewField(true);
                      setEditButtonvisible(true);
                      setAddField(true);
                      resetForm();
                      valuesToForm();
                      if (dialog) {
                        dialog.handleClose();
                      }
                    }}
                    disabled={
                      dialog
                        ? dialog.isUpdate && ((editButtonVisible && addField) || (!editButtonVisible && !addField))
                        : (editButtonVisible && addField) || (!editButtonVisible && !addField)
                    }
                  />
                  <ConfirmDialogUI
                    handleChangeElement={() => {
                      addSourceLine(setFieldValue, values);
                    }}
                    show={showConfirmDialog}
                    onHide={() => {
                      setShowConfirmDialog(false);
                      setSourceData({});
                    }}
                    message={'A válaszott cikkhez tartozik forrásjegyzék. Importálja a forrásjegyzéket?'}
                  />
                  <ConfirmDialogUI
                    handleChangeElement={() => {
                      onProductionStatusChange(setFieldValue, values);
                    }}
                    show={showConfirmDialogForStatus}
                    onHide={() => {
                      setShowConfirmDialogForStatus(false);
                    }}
                    confirmButtonText="Igen"
                    message={'Átállítja a megadott státuszra a tétel sorok státuszát is?'}
                  />
                </Form>
              );
            }}
          </Formik>
        </div>
      </>

      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />

      <HistoryDialog
        open={historyDialogOpen}
        handleClose={() => {
          setHistoryDialogOpen(false);
        }}
        formId={submenu}
        lineId={selectedValues.id}
        fieldConfig={[]}
      />
    </>
  );
};
